(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/receivertype-info.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/receivertype-info.js');
"use strict";


const {
  RadioGroup,
  RadioButton
} = svs.ui.reactForm;
const {
  PHONE,
  EMAIL
} = svs.tickets_giftshop.constants.names;
const {
  PHONE_LABEL,
  EMAIL_LABEL
} = svs.tickets_giftshop.constants.form;
const {
  EmailInput,
  MobileInput
} = svs.ui.reactFormInputs;
const ReceiverTypeInfo = React.forwardRef((_ref, ref) => {
  let {
    email,
    phone,
    receiverType = PHONE,
    onInputChange,
    onReceiverTypeChange
  } = _ref;
  const isPhone = receiverType === PHONE;
  const isEmail = receiverType === EMAIL;
  const header = 'Hur vill du skicka lotterna?';
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "f-body"
  }, React.createElement("h2", {
    className: "tg-form-receiver-info-header h2 u-text-center margin-top-4 margin-bottom-3",
    ref: ref
  }, header), React.createElement("div", {
    className: "tg-receivertype-info gutter-sm-2"
  }, React.createElement("div", {
    className: "grid-row"
  }, React.createElement(RadioGroup, {
    className: "receiver-send-option-group col-sm-6 col-xs-12",
    size: "200"
  }, React.createElement(RadioButton, {
    checked: isPhone,
    onChange: onReceiverTypeChange,
    value: PHONE
  }, "Sms"), React.createElement(RadioButton, {
    checked: isEmail,
    onChange: onReceiverTypeChange,
    value: EMAIL
  }, "E-post")), React.createElement("div", {
    className: "col-sm-6 col-xs-12 data-hj-suppress"
  }, isPhone && React.createElement(MobileInput, {
    id: PHONE,
    label: PHONE_LABEL,
    name: PHONE,
    onChange: onInputChange,
    value: phone
  }), isEmail && React.createElement(EmailInput, {
    id: EMAIL,
    label: EMAIL_LABEL,
    name: EMAIL,
    onChange: onInputChange,
    value: email
  }))))));
});
svs.tickets_giftshop.gift.giftform.components.ReceiverTypeInfo = ReceiverTypeInfo;

 })(window);